<template>
	<div class="dl-login-container" v-on:click="close">
		<transition name="dl-login-toggle" v-on:after-leave="afterHidden" v-on:before-enter="onAnimationStart" v-on:before-leave="onAnimationStart" v-on:after-enter="onAnimationEnd">
			<div v-if="show" class='dl-login' v-on:click="stopClickPropagation($event)">
				<div>
					<h1>{{$t('str.LoginWithDialogLoop')}}</h1>
					<input v-model="email" :placeholder="$t('str.Email')" v-on:keyup.enter="login" :disabled='isLoggingIn' />
					<input type="password" v-model="password" :placeholder="$t('str.Password')" v-on:keyup.enter="login" :disabled='isLoggingIn' />
					<p><button v-on:click='login' :disabled='isLoggingIn'>{{$t('str.Login')}}</button></p>
					<p v-if="errorMessage" class="error">{{errorMessage}}</p>
					<p>{{$t('str.NeedAnAccount')}}</p>
					<p><a v-on:click="register">{{$t('str.Register')}}</a></p>
				</div>
				<a v-on:click="close" class="close-button">
			        <i class="fa fa-times"></i>
			    </a>
			</div>
		</transition>
	</div>
</template>

<script>

export default {
	props: {
		service: Object
	},

	data() {
		return {
			email: '',
			password: '',
			show: false,
			shouldRegister: false,
			errorMessage: undefined,
			isLoggingIn: false
		};
	},
	
	mounted() {
        setTimeout(() => {
            this.show = true;
        }, 1);
    },

	methods: {
		login() {
			if (!this.email || !this.password || this.email.trim() === '' || this.password.trim() === '') {
				return;
			}

			this.errorMessage = undefined;
			this.isLoggingIn = true;

			this.service.login('dialogloop', window.location.href, this.email, this.password).then(() => {
				this.close();
			}).catch((err) => {
				this.isLoggingIn = false;
				console.log(err);
				this.errorMessage = this.$t('str.LoginFailed');
			});
		},

		close() {
            this.show = false;
        },

        afterHidden() {
        	this.onAnimationEnd();
            this.$emit('close');

            if (this.shouldRegister) {
            	this.$emit('register');
            }
        },

		register() {
			this.shouldRegister = true;
			this.close();
		},

		stopClickPropagation() {
			if (event && event.stopPropagation) {
                event.stopPropagation();
            }
		},

		onAnimationStart() {
			document.body.style.overflowY = 'hidden';
			this.$el.style.overflowY = 'hidden';
		},

		onAnimationEnd() {
			document.body.style.overflowY = 'auto';
			this.$el.style.overflowY = 'auto';
		}
	}
}

</script>

<style lang="scss">

.dl-login-toggle-enter-active, .dl-login-toggle-enter-to, .dl-login-toggle-leave-active {
    transition: all 0.3s;
}

.dl-login-toggle-enter, .dl-login-toggle-leave-to {
    opacity: 0;
    transform: translateY(300px);
}

.dl-login-container {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    padding: 40px 10px 10px 10px;
    overflow: auto;
}

.dl-login {
	background: #fff;
	width: 100%;
	font-family: "Poppins", sans-serif;
	padding: 15px 20px 20px 20px;
	box-sizing: border-box;
	position: relative;
	max-width: 400px;
	margin: 0 auto;

	& > div {
		width: 100%;
		text-align: center;
	}

	h1 {
		text-align: center;
		color: #d4451d;
		font-size: 1em;
    	font-weight: 100;
    	margin-bottom: 30px;
	}

	input {
		padding: 10px;
		width: 100%;
		margin-bottom: 10px;
		border: 1px solid #d2d8d8;
	    font-size: 0.8rem;
	    color: #242424;
	    box-sizing: border-box;
	}

	input:focus {
		outline: none;
	}

	input:disabled {
		color: #a2a2a2;
	}

	button {
		background-color: #d4451d;
		color: #fff;
		text-decoration: none;
		font-size: 0.8em;
		letter-spacing: 0.5px;
		padding: 10px 35px;
		box-shadow: 0 0 0 0 rgba(0, 0, 0, 0);
		border: none;
		border-radius: 0;
		outline: 0;
		text-transform: uppercase;
		margin: 10px 0 20px 0;
		cursor: pointer;
	}

	button:disabled {
		background-color: #a2a2a2;
		cursor: default;
	}

	a {
		color: #d4451d;
		cursor: pointer;
		-moz-user-select: none;
	    -webkit-user-drag: none;
	    -webkit-user-select: none;
	    -ms-user-select: none;
	}

	p {
		margin: 0;
		-moz-user-select: none;
	    -webkit-user-drag: none;
	    -webkit-user-select: none;
	    -ms-user-select: none;
	}

	.close-button {
		position: absolute;
		right: 20px;
		top: 10px;
		color: #d4451d;
		cursor: pointer;
	}

	.error {
		font-size: 0.8em;
		text-align: center;
		margin: 5px 0 15px 0;
		color: #d4451d;
	}
}

</style>



// WEBPACK FOOTER //
// DLLogin.vue?2d77a6db